// i18n area 'cluster' — locale el-GR (task #171, onda 4): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/cluster.el-GR.meta.json.
import type { enUS } from './cluster'

export const elGR: typeof enUS = {
  cluster: {
    // #233 — gli accessi di garanzia di un nodo (tradotto dall'italiano)
    nodeAccess: {
      title: 'Προσβάσεις εγγύησης',
      subtitle: 'Η πόρτα σέρβις του κόμβου: η πρόσβαση μόνο για ανάγνωση με προσωρινό κωδικό και ο λογαριασμός έκτακτης ανάγκης με τον κωδικό του χρηματοκιβωτίου',
      readOnlyTitle: 'Πρόσβαση μόνο για ανάγνωση (trantor)',
      stateNone: 'κλειστή',
      stateGranted: 'ανοιχτή',
      stateGrantedPending: 'παραχωρήθηκε — εφαρμόζεται στον κόμβο',
      grantedBy: 'Παραχωρήθηκε από',
      grantedAt: 'Παραχωρήθηκε στις',
      expiresAt: 'Λήγει στις',
      reason: 'Αιτία',
      endedAt: 'Κλειστή',
      endedReason: {
        revoked: 'ανακλήθηκε',
        expired: 'έληξε (TTL)',
        reboot: 'επανεκκίνηση του κόμβου',
        failed: 'δεν εφαρμόστηκε (η εργασία απέτυχε)'
      },
      grant: 'Παραχώρηση πρόσβασης μόνο για ανάγνωση…',
      grantTitle: 'Παραχώρηση πρόσβασης μόνο για ανάγνωση',
      grantSubmit: 'Παραχώρηση',
      grantError: 'Η παραχώρηση απορρίφθηκε',
      grantConfirm: 'Το TVirt δημιουργεί έναν προσωρινό κωδικό για τον χρήστη συστήματος «trantor» (μόνο ανάγνωση: journal και διάγνωση, χωρίς sudo) και τον ορίζει στον κόμβο με μια εργασία. Ο κωδικός εμφανίζεται ΜΟΝΟ μία φορά, κατά την επιβεβαίωση· παύει στη λήξη, στην ανάκληση ή στην επόμενη επανεκκίνηση του κόμβου.',
      reasonLabel: 'Αιτία',
      reasonHint: 'Γιατί ανοίγετε την πόρτα: μένει στην παραχώρηση, στον έλεγχο και στο ημερολόγιο',
      ttlLabel: 'Διάρκεια',
      ttlHours: '{n} ώ',
      revoke: 'Ανάκληση πρόσβασης μόνο για ανάγνωση…',
      revokeTitle: 'Ανάκληση πρόσβασης μόνο για ανάγνωση',
      revokeSubmit: 'Ανάκληση',
      revokeError: 'Η ανάκληση απορρίφθηκε',
      revokeConfirm: 'Η παραχώρηση τερματίζεται αμέσως και μια εργασία κλειδώνει ξανά τον χρήστη «trantor» στον κόμβο: ο προσωρινός κωδικός παύει να ισχύει.',
      passwordTitle: 'Κωδικός μόνο για ανάγνωση',
      passwordOnce: 'Αυτός ο κωδικός εμφανίζεται ΜΟΝΟ μία φορά: αντιγράψτε τον τώρα. Δεν αποθηκεύεται πουθενά και δεν θα μπορεί να διαβαστεί ξανά — αν τον χάσετε, παραχωρήστε ξανά.',
      passwordUser: 'Χρήστης',
      passwordLabel: 'Κωδικός',
      passwordHint: 'Ισχύει έως {until} ή έως την επόμενη επανεκκίνηση του κόμβου· χρησιμοποιήσιμος όταν ολοκληρωθεί η εργασία παραχώρησης. Πρόσβαση: ssh trantor@<διεύθυνση κόμβου>.',
      emergencyTitle: 'Τελευταία πρόσβαση έκτακτης ανάγκης (trantor-emergency)',
      lastLogin: '{time} μέσω {via} από {from}',
      lastLoginNone: 'καμία παρατηρήθηκε',
      lastLoginVia: {
        ssh: 'ssh',
        console: 'κονσόλα',
        sudo: 'sudo',
        unknown: 'άγνωστο'
      },
      emergencyHint: 'Ο λογαριασμός έκτακτης ανάγκης «trantor-emergency» (πλήρες sudo) είναι πάντα ενεργός με τον κωδικό που δημιουργήθηκε κατά την εγκατάσταση του κόμβου και φυλάσσεται στο χρηματοκιβώτιο: το TVirt δεν τον γνωρίζει, δεν τον εναλλάσσει και δεν τον ανακτά. Κάθε σύνδεση αναφέρεται εδώ και στο ημερολόγιο συμβάντων.'
    },
    nodeFirewall: {
      tab: 'Τείχος προστασίας',
      title: 'Τείχος προστασίας των κόμβων',
      subtitle: 'Η στάση του ruleset nftables που κάθε κόμβος εφαρμόζει στον εαυτό του — το μοναδικό τείχος προστασίας ενός κόμβου (το firewalld είναι απενεργοποιημένο)',
      modeLabel: 'Στάση',
      mode: {
        disabled: 'Απενεργοποιημένη — κανένα ruleset στους κόμβους',
        permissive: 'Επιτρεπτική — μετρά και καταγράφει, δεν απορρίπτει τίποτα',
        enforced: 'Επιβεβλημένη — μπαίνει μόνο το παράγωγο μητρώο'
      },
      hint: {
        disabled: 'Όπως είναι σήμερα: οι κόμβοι δεν φέρουν κανένα ruleset. Περάστε σε επιτρεπτική για να ΔΙΑΒΑΣΕΤΕ τι θα απορριπτόταν πριν απορριφθεί.',
        permissive: 'Κάθε κόμβος εφαρμόζει το δικό του παράγωγο ruleset με policy accept: ό,τι θα απέρριπτε η επιβεβλημένη λειτουργία μετριέται και καταγράφεται (πρόθεμα journal «tvirt-node would-drop:»). Τίποτα δεν μπλοκάρεται.',
        enforced: 'Κάθε κόμβος εφαρμόζει το δικό του παράγωγο ruleset με policy drop: ssh και API από παντού, store / live migration / overlay / Ceph μόνο από τα μέλη, οι listeners των υπηρεσιών δικτύου από το εξυπηρετούμενο δίκτυο. Κάθε αλλαγή είναι ένα apply με επιβεβαίωση — ένας κόμβος που δεν καταφέρνει να επιβεβαιώσει γυρίζει πίσω μόνος του.'
      },
      confirmTitle: 'Επιβολή του τείχους προστασίας των κόμβων;',
      confirmBody: 'Κάθε κόμβος εφαρμόζει το ruleset με επιβεβαίωση: ελέγχει backend, store και ssh μέσα από τους νέους κανόνες εντός της προθεσμίας και επιβεβαιώνει — αλλιώς γυρίζει μόνος του στο προηγούμενο ruleset. Διαβάστε πρώτα τους μετρητές της επιτρεπτικής λειτουργίας στους κόμβους.',
      confirmSubmit: 'Επιβολή',
      confirmCancel: 'Ακύρωση',
      lensTitle: 'Τείχος προστασίας του κόμβου',
      loadError: 'Δεν ήταν δυνατή η φόρτωση του φακού του τείχους προστασίας του κόμβου',
      noReport: 'Καμία αναφορά τείχους προστασίας από αυτόν τον κόμβο, ακόμη — ο worker αναφέρει στο επόμενο πέρασμα',
      firewalldActive: 'Σε αυτόν τον κόμβο τρέχει το firewalld: το τείχος προστασίας του κόμβου αρνείται να εφαρμοστεί δίπλα του (κάντε mask το firewalld)',
      conditionUnconfirmed: 'Κανένα επιβεβαιωμένο ruleset, ακόμη — ο κόμβος είναι ανοιχτός',
      conditionRolledBack: 'Το τελευταίο apply γύρισε πίσω — η ίδια γενιά δεν ξαναδοκιμάζεται μέχρι να αλλάξει το μητρώο ή να αλλάξει ξανά η στάση',
      lastError: 'Τελευταίο σφάλμα',
      posture: 'Στάση',
      observedAt: 'Παρατηρήθηκε',
      desiredGeneration: 'Επιθυμητή γενιά',
      componentTitle: 'Συστατικό κόμβου',
      componentSubtitle: 'tvirt-node-firewall — εφαρμόζει στο boot το επιβεβαιωμένο ruleset, γυρίζει πίσω μόνο του ένα μη επιβεβαιωμένο',
      componentAbsent: 'Το συστατικό δεν έχει αναφέρει ακόμη',
      phase: 'Φάση',
      phases: {
        none: 'Ποτέ δεν εφαρμόστηκε',
        applied: 'Εφαρμόστηκε — σε αναμονή επιβεβαίωσης',
        confirmed: 'Επιβεβαιώθηκε',
        rolledBack: 'Γύρισε πίσω'
      },
      generation: 'Γενιά',
      appliedAt: 'Εφαρμόστηκε στις',
      confirmedAt: 'Επιβεβαιώθηκε στις',
      deadline: 'Προθεσμία του rollback',
      lastRollback: 'Τελευταίο rollback',
      registryTitle: 'Παράγωγο μητρώο',
      registrySubtitle: 'Οι θύρες που ανοίγει αυτός ο κόμβος, ανά κλάση και προέλευση — παράγωγες από τη συστοιχία, ποτέ επεξεργασμένες με το χέρι',
      registryEmpty: 'Τίποτα παράγωγο — στάση απενεργοποιημένη χωρίς επιβεβαιωμένο ruleset, ή καμία αναφορά ακόμη',
      colClass: 'Κλάση',
      colPort: 'Θύρα',
      colSource: 'Πηγή',
      colOrigin: 'Προέλευση',
      classes: {
        public: 'Δημόσια',
        internode: 'Διακομβική',
        tenant: 'Tenant'
      },
      sourceMembers: 'μόνο τα μέλη',
      sourceAnywhere: 'από παντού',
      sourceBridge: 'σε {iface}'
    },
    derivationDerived: 'παράγωγο',
    derivationDiverged: 'αποκλίνον',
    derivationDerivedTip: 'Το έγγραφο δικτύου είναι ΠΑΡΑΓΩΓΟ του fabric {fabric} και συμπίπτει ακόμα με το render στις τρέχουσες εισόδους — κλικ για το σχέδιο παραγωγής.',
    derivationDivergedTip: 'Η παραγωγή από το fabric {fabric} άλλαξε μετά το τελευταίο apply (fabric, καλωδίωση, ρόλοι ή αναφορές) — κλικ για το εκκρεμές diff.',
    derivationRetiring: {
      one: '{n} διεύθυνση αποστραγγίζεται',
      other: '{n} διευθύνσεις αποστραγγίζονται'
    },
    standaloneHint: 'Αυτός ο κόμβος δεν έχει συστοιχία: δεν έχει εγκατασταθεί ακόμη. Οι συστοιχίες δημιουργούνται Ή γίνονται join κατά την εγκατάσταση — το διακριτικό που παράγεται από τον πίνακα «Διακομιστές» ενός μέλους δίνεται στον installer (dev: db:init-cluster / db:init-join).',
    reducedHint: 'Τα δικαιώματά σας καλύπτουν ένα scope, όχι ολόκληρη τη συστοιχία: η απογραφή του στόλου — κόμβοι, ρυθμίσεις και συσκευές — είναι ορατή μόνο σε όσους διαχειρίζονται τη συστοιχία.',
    phaseReady: 'Έτοιμος',
    phaseForming: 'Σε σχηματισμό',
    storeMembers: 'Μέλη της αποθήκης',
    watermark: 'Κατώφλι σύγκλισης',
    configGeneration: 'Γενιά διαμόρφωσης',
    converged: 'ευθυγραμμισμένη',
    behind: 'πίσω — {m} / {n}',
    revision: 'Αναθεώρηση',
    rolesTitle: 'Ρόλοι δικτύου',
    rolesSubtitle: 'Διευθύνσεις ανά μέλος για κάθε κλάση κίνησης — η ίδια η συνδεσιμότητα ζει στο δίκτυο του host',
    roleManagement: 'Management',
    roleLiveMigration: 'Live Migration',
    roleInherited: 'κληρονομεί το management',
    settingsTitle: 'Ρυθμίσεις',
    settingsSubtitle: 'Πολιτική ασφαλείας σε επίπεδο συστοιχίας — αξιολογείται από κάθε κόμβο από το τοπικό του αντίγραφο',
    taskRetentionTitle: 'Διατήρηση εργασιών',
    taskRetentionSubtitle: 'Ενοποιημένο GC για όλες τις εργασίες — οι ολοκληρωμένες εργασίες πέρα από την ηλικία ή το ανώτατο όριο συλλέγονται, ποτέ όσες βρίσκονται σε εξέλιξη',
    taskRetentionMaxAge: 'Μέγιστη ηλικία (ημέρες)',
    taskRetentionMaxCount: 'Μέγιστος αριθμός εργασιών',
    eventRetentionTitle: 'Διατήρηση γεγονότων',
    eventRetentionSubtitle: 'Το GC του ημερολογίου — πολιτική ανεξάρτητη από των εργασιών: η εργασία είναι ουρά, το γεγονός είναι μνήμη',
    eventRetentionMaxAge: 'Μέγιστη ηλικία (ημέρες)',
    eventRetentionMaxCount: 'Μέγιστος αριθμός γεγονότων',
    spaceThresholdsTitle: 'Κατώφλια χώρου',
    spaceThresholdsSubtitle: 'Πότε ένας αποθηκευτικός χώρος που γεμίζει μπαίνει στο ημερολόγιο (και στις ειδοποιήσεις)',
    spaceLowPct: 'Προειδοποίηση από (% σε χρήση)',
    spaceCriticalPct: 'Κρίσιμο από (% σε χρήση)',
    spaceOrderError: 'Το κρίσιμο δεν μπορεί να είναι κάτω από την προειδοποίηση',
    spaceThresholdsHint: 'Ρυθμίζονται μόνο οι είσοδοι: την έξοδο την παράγει η μηχανή, 5 μονάδες κάτω από κάθε κατώφλι, ώστε ένας χώρος πάνω στη γραμμή να μη γίνει ποτέ μετρονόμος',
    failoverReserveTitle: 'Εφεδρεία failover',
    failoverReserveSubtitle: 'Έλεγχος εισδοχής N+1 — RAM που διατηρείται ελεύθερη ώστε η συστοιχία να μπορεί να επανεκκινήσει το φορτίο εργασίας της μετά την απώλεια κόμβων',
    failoverReserveTolerate: 'Κόμβοι των οποίων η απώλεια θα είναι ανεκτή',
    failoverReserveOff: '0 — η εφεδρεία είναι ανενεργή: καμία εκκίνηση δεν απορρίπτεται ποτέ για χωρητικότητα failover',
    failoverReserveOn: 'Μια εκκίνηση που θα παραβίαζε την εφεδρεία απορρίπτεται με ένα 412 που εξηγεί τους αριθμούς',
    networkShapingTitle: 'Δίκαιη κατανομή εύρους ζώνης',
    networkShapingSubtitle: 'Τα τρία βάρη τυπολογίας του δέντρου shaping ανά uplink — δρουν μόνο υπό συναγωνισμό',
    networkShapingRest: 'Βάρος του υπολοίπου (επίπεδο ελέγχου, storage, αντίγραφα)',
    networkShapingOverlay: 'Βάρος των δικτύων overlay',
    networkShapingLiveMigration: 'Βάρος της live migration',
    networkShapingHint: 'Εγγυημένο μερίδιο = βάρος / άθροισμα των τριών (προεπιλογή 300 / 100 / 200, καθένα από 1 έως 10000)· σε αδρανή σύνδεση κάθε κλάση μπορεί να πάρει όλο το εύρος ζώνης',
    debugModeTitle: 'Λειτουργία debug',
    debugModeSubtitle:
      'Λεπτομερή σφάλματα στις γενικές ειδοποιήσεις του GUI — για να δείτε την πραγματική αιτία όταν μια ενέργεια που «απέτυχε» στην πραγματικότητα πέτυχε',
    debugModeLabel: 'Λειτουργία debug ενεργοποιημένη',
    debugModeOn: 'Οι γενικές ειδοποιήσεις σφάλματος προσθέτουν την υποκείμενη αιτία — εσωτερικές λεπτομέρειες ορατές σε κάθε χειριστή',
    debugModeOffHint: 'Ανενεργή — οι γενικές ειδοποιήσεις σφάλματος παραμένουν γενικές, χωρίς εσωτερικές λεπτομέρειες',
    nodeDetailsAction: 'Λεπτομέρειες κόμβου',
    node: {
      docTitle: 'Κόμβος',
      notFound: 'Ο κόμβος δεν βρέθηκε',
      tabOverview: 'Επισκόπηση',
      tabStats: 'Στατιστικά',
      tabNetwork: 'Δίκτυο',
      tabSettings: 'Τοπικές ρυθμίσεις',
      identityTitle: 'Ταυτότητα',
      heartbeatTitle: 'Παλμός',
      ysqlPort: 'Θύρα YSQL',
      revision: 'Αναθεώρηση διαμόρφωσης',
      versionsTitle: 'Παρατηρούμενες εκδόσεις',
      heartbeatSubtitle: 'Η τελευταία κατάσταση που ανέφερε ο κόμβος για τον εαυτό του',
      cpuTitle: 'CPU',
      cpuModelTitle: 'Μοντέλο CPU',
      memoryTitle: 'Μνήμη',
      hugePagesTitle: 'Τεράστιες σελίδες',
      hugePagesPool: '{size}: {free} ελεύθερες από {total}',
      hugePagesNone: 'Κανένα pool',
      hugePagesNoneHint: 'Ο κόμβος δεν έχει δεσμευμένες τεράστιες σελίδες: οι VM που ζητούν τέτοιες δεν μπορούν να εκκινήσουν εδώ. Το pool δηλώνεται στον κόμβο, με τις παραμέτρους hugepagesz και hugepages του πυρήνα ή γράφοντας στο nr_hugepages.',
      usageTitle: 'Τρέχουσα χρήση',
      usageMem: 'RAM {n} MiB',
      usageUnknown: 'δεν παρατηρήθηκε — κανένα φρέσκο δείγμα',
      statsNoData: 'Κανένα δεδομένο στο διάστημα — οι χρονοσειρές του κόμβου δειγματοληπτούνται από τον ίδιο τον κόμβο και σερβίρονται τοπικά.',
      observedTitle: 'Παρατηρούμενη κατάσταση',
      observedSubtitle: 'Υπηρεσίες και τοπικά asset του κόμβου, όπως τα βλέπει ο worker'
    },
    editRolesTitle: 'Επεξεργασία ρόλων δικτύου',
    memberNode: 'Κόμβος',
    memberIp: 'Διεύθυνση IP',
    addMember: 'Προσθήκη μέλους',
    lmInherit: 'Χρήση των διευθύνσεων management',
    roleIpHint: 'Η προσθήκη και η αφαίρεση μελών είναι ελεύθερες· η επιτόπια αλλαγή της IP ενός υπάρχοντος μέλους απορρίπτεται — η ροή μετεγκατάστασης IP φτάνει σε επόμενο γύρο.',
    roleError: 'Δεν ήταν δυνατή η ενημέρωση των ρόλων',
    nodesTitle: 'Κόμβοι',
    addNodeTitle: 'Προσθήκη κόμβου στη συστοιχία',
    addNode: 'Προσθήκη κόμβου',
    addNodeError: 'Δεν ήταν δυνατή η προεγγραφή του κόμβου',
    nodeName: 'Όνομα κόμβου',
    nodeNameHint: 'πρέπει να ταιριάζει με το όνομα που ορίστηκε κατά την εγκατάσταση',
    nodeIp: 'IP management',
    colName: 'Όνομα',
    colPhase: 'Φάση',
    colServices: 'Υπηρεσίες',
    colWatermark: 'Watermark',
    colLastSeen: 'Τελευταία επαφή',
    colUps: 'UPS',
    upsCordonChip: 'κορδόνι UPS',
    upsCordonTip: 'Ο κόμβος καταδίκασε τον εαυτό του βάσει των γεγονότων του UPS του ({time}): αίρει μόνος του το κορδόνι όταν το δίκτυο σταθεροποιηθεί και η μπαταρία φορτιστεί',
    upsUnreachable: 'UPS μη προσβάσιμο',
    upsOnBattery: 'Σε μπαταρία',
    upsOnLine: 'Σε δίκτυο',
    upsLowBattery: 'χαμηλή μπαταρία',
    upsNoEstimateChip: 'αυτονομία μη εκτιμημένη',
    upsNoEstimateTip: 'Το UPS δεν δημοσιεύει εκτίμηση αυτονομίας: ο κόμβος καταδικάζεται μόνο από τη σημαία LB (χαμηλή μπαταρία) του UPS — ρυθμίστε battery.runtime.low / LB στο ίδιο το UPS',
    upsLaneTip: 'Διαδρομή τερματισμού UPS από {since}: καταδικάστηκε από {by}',
    upsUnit: 'μονάδα',
    upsStatus: 'κατάσταση NUT',
    upsLoad: 'φορτίο',
    upsOnBatterySince: 'σε μπαταρία από',
    upsOnLineSince: 'σε δίκτυο από',
    upsError: 'σφάλμα',
    upsObservedAt: 'παρατηρήθηκε',
    upsNone: 'καμία μονάδα UPS δεν εξυπηρετεί αυτόν τον κόμβο',
    upsBy: {
      runtime: 'αυτονομία κάτω από το όριο',
      lowBattery: 'σημαία LB του UPS',
    },
    upsLane: {
      evacuate: 'εκκένωση',
      local: 'τερματισμός επί τόπου',
    },
    upsPhase: {
      draining: 'drain',
      stoppingGuests: 'διακοπή φιλοξενούμενων',
      stoppingServices: 'διακοπή υπηρεσιών',
      poweredOff: 'απενεργοποιημένος',
    },
    upsTitle: 'UPS (NUT)',
    upsSubtitle: 'Μονάδες UPS και όρια: ο κόμβος καταδικάζεται με αυτονομία ≤ όριο ή σημαία LB (πάντα σεβαστή), επανέναρξη με υστέρηση',
    upsRuntimeThreshold: 'Όριο αυτονομίας (s)',
    upsRuntimeThresholdHint: 'Σε μπαταρία, με εκτιμώμενη αυτονομία ≤ όριο ο κόμβος τερματίζεται με τη σειρά (προεπιλογή 300)',
    upsResumeStable: 'Δίκτυο σταθερό για (s)',
    upsResumeStableHint: 'Επανέναρξη μόνο με συνεχές δίκτυο τουλάχιστον τόσα δευτερόλεπτα (προεπιλογή 60)',
    upsResumeCharge: 'Ελάχιστη φόρτιση στην επανέναρξη (%)',
    upsResumeChargeHint: 'Και μπαταρία φορτισμένη τουλάχιστον σε αυτό το ποσοστό (προεπιλογή 25)',
    upsPolicyNote: 'Η σημαία LB (χαμηλή μπαταρία) του UPS καταδικάζει πάντα και δεν απενεργοποιείται· δεν υπάρχει όριο στον χρόνο σε μπαταρία. Κάθε μονάδα μπορεί να παρακάμψει τους τρεις αριθμούς.',
    upsUnitNew: 'νέα μονάδα',
    upsUnitSelectors: '{n} επιλογέας/είς ετικετών (μόνο CLI)',
    upsUnitName: 'Όνομα μονάδας',
    upsUnitMode: 'Λειτουργία',
    upsModeExternal: 'εξωτερική (ξένο upsd)',
    upsModeManaged: 'διαχειριζόμενη (UPS συνδεδεμένο σε κόμβο)',
    upsUnitUpsname: 'Όνομα NUT (upsname)',
    upsUnitHost: 'Κεντρικός υπολογιστής upsd',
    upsUnitAttachedNode: 'Συνδεδεμένος κόμβος',
    upsUnitDriver: 'Πρόγραμμα οδήγησης NUT',
    upsUnitDriverHint: 'usbhid-ups, nutdrv_qx, snmp-ups, …',
    upsUnitDevice: 'Συσκευή του προγράμματος οδήγησης',
    upsUnitDeviceHint: 'η γραμμή port= του ups.conf: κενό = auto',
    upsUnitPort: 'Θύρα upsd',
    upsUnitServedNodes: 'Εξυπηρετούμενοι κόμβοι',
    upsUnitServedNodesHint: 'ονόματα κόμβων χωρισμένα με κόμματα (οι επιλογείς ετικετών περνούν από το CLI)',
    upsUnitOverrideHint: 'κενό = προεπιλογή συμπλέγματος',
    upsUnitAdd: 'Προσθήκη μονάδας',
    unreachableSince: 'Μη προσβάσιμος — τελευταίος παλμός {time}',
    overlaysChip: 'overlay',
    overlaysBehind: 'Το dataplane επικάλυψης δεν έχει υλοποιήσει ακόμη την τρέχουσα διαμόρφωση επικάλυψης',
    overlaysError: 'Το τελευταίο πέρασμα συμφιλίωσης επικάλυψης απέτυχε: {error}',
    storeChip: 'αποθήκη',
    phase: {
      'pending-join': 'Σε αναμονή join',
      'joining': 'Σε ένταξη',
      'member': 'Μέλος'
    },
    tokenTitle: 'Join token',
    tokenOnce: 'Εμφανίζεται μόνο τώρα — αντιγράψτε το αμέσως, δεν θα είναι ξανά αναγνώσιμο',
    copy: 'Αντιγραφή',
    copied: 'Αντιγράφηκε',
    close: 'Κλείσιμο',
    revokeTitle: 'Ανάκληση προεγγραφής',
    revoke: 'Ανάκληση',
    revokeError: 'Δεν ήταν δυνατή η ανάκληση της εγγραφής',
    promote: 'Προαγωγή σε μέλος αποθήκης',
    demote: 'Αφαίρεση του ρόλου store-member',
    troubleshoot: 'Αντιμετώπιση προβλημάτων',
    promoteTitle: 'Προαγωγή σε μέλος αποθήκης',
    demoteTitle: 'Αφαίρεση του ρόλου store-member',
    promoteHint: 'Ο κόμβος εντάσσεται στην απαρτία των master YugabyteDB. Η πραγματική HA απαιτεί τρία μέλη αποθήκης.',
    demoteHint: 'Ο κόμβος αποχωρεί από την απαρτία των master και σταματά τις υπηρεσίες αποθήκης του.',
    storeError: 'Η αλλαγή του store-member απορρίφθηκε',
    attest: 'Βεβαίωση απενεργοποίησης…',
    attestTitle: 'Βεβαίωση ότι ο κόμβος είναι απενεργοποιημένος',
    attestSubmit: 'Βεβαίωση απενεργοποίησης',
    attestConfirm: 'Δηλώνετε αυτόν τον κόμβο απενεργοποιημένο, με δική σας ευθύνη: το να βεβαιώσετε έναν κόμβο που στην πραγματικότητα είναι ζωντανός ενέχει τον κίνδυνο VM σε διπλή εκτέλεση. Οι εργασίες του αποτυγχάνουν και η αρμοδιότητα των VM του γίνεται μεταβιβάσιμη.',
    attestError: 'Η βεβαίωση απορρίφθηκε',
    attestedChip: 'βεβαιωμένα απενεργοποιημένος',
    maintenanceChip: 'συντήρηση',
    guestToolsChip: 'TVirt Guest Tools (τοπικό asset ISO του κόμβου)',
    maintenanceEnter: 'Ενεργοποίηση συντήρησης',
    maintenanceExit: 'Απενεργοποίηση συντήρησης',
    maintenanceEnterTitle: 'Ενεργοποίηση συντήρησης',
    maintenanceExitTitle: 'Απενεργοποίηση συντήρησης',
    maintenanceEnterSubmit: 'Ενεργοποίηση συντήρησης',
    maintenanceExitSubmit: 'Απενεργοποίηση συντήρησης',
    maintenanceEnterConfirm: 'Ο κόμβος τίθεται σε αποκλεισμό και αδειάζει: οι υπηρεσίες δικτύου και οι περιπτώσεις App των οποίων κατέχει την authority μεταφέρονται (οι περιπτώσεις εν ψυχρώ: σταματούν και θερίζονται εδώ, αναδημιουργούνται στον κόμβο προορισμού — διακοπή), οι ενεργές VM μεταναστεύουν ζωντανά όπου γίνεται και αλλιώς σταματούν ομαλά, οι εργασίες σε εξέλιξη ολοκληρώνονται, η νέα εργασία αναμένει και οι σταματημένες VM χάνουν την authority τους — το Proximity τις ξανατοποθετεί στην επόμενη εκκίνηση. Τίποτα δεν επιστρέφει μόνο του στο τέλος της συντήρησης.',
    maintenanceExitConfirm: 'Ο κόμβος ξαναρχίζει να δουλεύει και το Proximity τον λαμβάνει ξανά υπόψη για την τοποθέτηση. Οι VM επιστρέφουν μόνο όταν εκκινηθούν.',
    maintenanceError: 'Το αίτημα συντήρησης απορρίφθηκε',
    maintenancePlanTitle: 'Σχέδιο εκκένωσης',
    maintenancePlanLoading: 'Υπολογισμός του σχεδίου εκκένωσης…',
    maintenancePlanError: 'Δεν ήταν δυνατή η φόρτωση του σχεδίου εκκένωσης — η εκκένωση θα μετεγκαταστήσει ούτως ή άλλως όπου είναι δυνατόν και θα σταματήσει τα υπόλοιπα.',
    maintenancePlanEmpty: 'Τίποτα προς εκκένωση σε αυτόν τον κόμβο — καμία ενεργή υπηρεσία δικτύου, καμία περίπτωση App που ζητείται σε εκτέλεση, καμία ενεργή VM.',
    maintenancePlanSummary: '{migrate} αντικείμενα θα μεταναστεύσουν (VM, υπηρεσίες δικτύου, περιπτώσεις App), {stop} θα σταματήσουν ή θα μείνουν εκεί που είναι.',
    maintenancePlanReserve_ok: 'Εφεδρεία failover μετά την εκκένωση: ανέπαφη — απομένουν {headroom} GiB εκκινήσιμα με ανοχή απώλειας {n} κόμβου/ων.',
    maintenancePlanReserve_eroded: 'Εφεδρεία failover μετά την εκκένωση: σχεδόν εξαντλημένη — απομένουν μόνο {headroom} GiB από τα {reserve} GiB που διατηρούνται ελεύθερα για {n} αστοχία/ες κόμβων.',
    maintenancePlanReserve_exhausted: 'Εφεδρεία failover μετά την εκκένωση: ΕΞΑΝΤΛΗΜΕΝΗ — λείπουν {headroom} GiB από τα {reserve} GiB που χρειάζονται για την ανοχή {n} αστοχίας/ών κόμβων. Όσο αυτός ο κόμβος είναι εκτός, οι νέες εκκινήσεις VM θα απορρίπτονται.',
    maintenancePlanReserve_unknown: 'Εφεδρεία failover μετά την εκκένωση: μη υπολογίσιμη — κανένας εναπομείνας κόμβος δεν έχει δηλώσει τη μνήμη του.',
    maintenancePlanReserveHugePages: 'Τεράστιες σελίδες των {size} μετά την εκκένωση — ελεύθερες: {free} από {capacity}, απαιτούμενες ως εφεδρεία: {reserve}.',
    maintenancePlanActionMigrate: 'μετεγκαθίσταται',
    maintenancePlanActionMigrateWarning: 'μετεγκαθίσταται (με παραβίαση soft κανόνα)',
    maintenancePlanActionStop: 'σταματά',
    maintenancePlanActionBlocked: 'εμποδίζεται',
    maintenancePlanKindVm: 'VM',
    maintenancePlanKindNetsvc: 'υπηρεσία δικτύου',
    maintenancePlanKindApp: 'περίπτωση App',
    maintenancePlanColdMove: 'Μετακίνηση εν ψυχρώ: το pod σταματά και θερίζεται εδώ και αναδημιουργείται στον κόμβο προορισμού από τον worker του — διακοπή έως το επόμενο pass του worker προορισμού.',
    caFingerprint: 'Αποτύπωμα της CA της συστοιχίας',
    staleChip: 'μη ενημερωμένος',
    troubleshootTitle: 'Αντιμετώπιση προβλημάτων της αποθήκης',
    restartStore: 'Επανεκκίνηση των υπηρεσιών της αποθήκης',
    restartHint: 'Αν η αποθήκη παρουσιάζει προβλήματα, επανεκκινήστε τις υπηρεσίες της. Προχωρημένο — χρήση με προσοχή.',
    restartQueued: 'Η εργασία επανεκκίνησης μπήκε στην ουρά',
    restartError: 'Δεν ήταν δυνατή η επανεκκίνηση των υπηρεσιών',
    svcActive: 'ενεργή',
    svcWanted: 'επιθυμητή, όχι ενεργή',
    svcStopped: 'σταματημένη',
    noServices: 'Καμία υπηρεσία δεν αναφέρθηκε'
  },
  clusterDevices: {
    gpusTitle: 'GPU / PCIe',
    gpusSubtitle: 'Η απογραφή GPU όλης της συστοιχίας ομαδοποιημένη ανά μοντέλο — οι παρατηρούμενες κάρτες ανά κόμβο, με τις επισημασμένες εγγραφές και τις ετικέτες τους',
    usbTitle: 'Πόροι USB',
    usbSubtitle: 'Η απογραφή USB όλης της συστοιχίας ομαδοποιημένη ανά μοντέλο — οι παρατηρούμενες συσκευές ανά κόμβο, με τις εγγραφές και των δύο μοντέλων (ανά συσκευή, ανά θύρα) και τις ετικέτες τους',
    markedChip: '{n} χρησιμοποιήσιμα από το TVirt',
    orphanChipGpu: '{n} ορφανές',
    orphanChipUsb: '{n} ορφανά',
    colNode: 'Κόμβος',
    colRegistration: 'Εγγραφή',
      noRegsHint: 'Καμία εγγραφή — η συσκευή επισημαίνεται ως «χρησιμοποιήσιμη από το TVirt» από το παράθυρο διαλόγου του κόμβου (Κόμβοι › κόμβος › Ρυθμίσεις).',
      colDevice: 'Συσκευή',
      colObserved: 'Παρατηρήθηκαν',
      colRegs: 'Εγγραφές',
      regsNone: 'καμία',
      colPci: 'Διεύθυνση PCIe',
      colIdentity: 'Ταυτότητα / θύρα',
      colClasses: 'Κλάσεις (ετικέτες)',
      colActions: 'Ενέργειες',
      manageOnNode: 'Διαχείριση στον κόμβο {node} (η επισήμανση ζει στο παράθυρο διαλόγου του κόμβου)',
      introTitle: 'Η απογραφή της συστοιχίας για τις συσκευές USB και PCIe που είναι χρησιμοποιήσιμες από το TVirt©.',
      introStep1: '1. Οι κόμβοι ανακαλύπτουν μόνοι τους τις GPU και τις συσκευές USB τους (απογραφή στον παλμό).',
      introStep2: '2. Μια συσκευή επισημαίνεται ως «χρησιμοποιήσιμη από το TVirt» από το παράθυρο διαλόγου του ΚΟΜΒΟΥ (Κόμβοι › κόμβος › Ρυθμίσεις) — η επισήμανση τη δένει στο vfio και την εγγράφει εδώ.',
      introStep3: '3. Εδώ δίνετε στις εγγραφές τις ΚΛΑΣΕΙΣ τους μέσω ετικετών (π.χ. gpu_class=compute): οι απαιτήσεις των VM θα ζητούν μια κλάση, και ο χρονοπρογραμματιστής θα επιλέγει έναν κόμβο με ελεύθερη συμβατή συσκευή.',
    colMode: 'Λειτουργία',
    colState: 'Κατάσταση',
    colNotes: 'Σημειώσεις',
    colTags: 'Ετικέτες',
    modeDevice: 'ανά συσκευή',
    modePort: 'ανά θύρα',
    usable: 'χρησιμοποιήσιμη',
    orphanGpu: 'ορφανή',
    orphanUsb: 'ορφανή',
    hubChip: 'hub',
    orphanPortsTitle: 'Εγγραφές ανά θύρα χωρίς συνδεδεμένη συσκευή — επανασυνδέστε μια συσκευή ή αναιρέστε την επισήμανσή τους από τον κόμβο',
    gpusEmpty: 'Καμία GPU δεν έχει παρατηρηθεί ακόμη σε κανέναν κόμβο',
    usbEmpty: 'Καμία συσκευή USB δεν έχει παρατηρηθεί ακόμη σε κανέναν κόμβο'
  },

  // Κοινό λεξιλόγιο των φορμών ρυθμίσεων (refactoring 2026-07-24): τα πεδία
  // ασφαλείας τροφοδοτούν την κάρτα της σελίδας «Συστοιχία», τα πεδία κόμβου τη
  // σελίδα node-settings — η σελίδα /system/settings για την οποία γεννήθηκαν
  // είναι νεκρή.
  settings: {
    passwordMinLength: 'Ελάχιστο μήκος κωδικού πρόσβασης',
    sessionIdle: 'Χρονικό όριο αδράνειας συνεδρίας (λεπτά)',
    lockoutThreshold: 'Κλείδωμα μετά από αποτυχημένες προσπάθειες',
    lockoutDuration: 'Διάρκεια κλειδώματος (λεπτά)',
    keyboardLayout: 'Διάταξη πληκτρολογίου',
    keyboardLayoutHint: 'π.χ. it, en-us — κενό για την προεπιλογή του QEMU',
    syslogEndpoint: 'Τελικό σημείο syslog',
    syslogEndpointHint: 'host:θύρα — κενό για απενεργοποίηση της προώθησης',
    syslogTls: 'TLS',
    maxQueued: 'Μέγιστες εργασίες σε ουρά',
    concurrency: 'Παραλληλισμός του worker',
    concurrencyHint: 'Εφαρμόζεται ζωντανά από τον worker',
    notesTitle: 'Σημειώσεις',
    save: 'Αποθήκευση',
    saved: 'Οι ρυθμίσεις αποθηκεύτηκαν',
    saveError: 'Δεν ήταν δυνατή η αποθήκευση των ρυθμίσεων'
  },
  localSettings: {
    derivedChip: 'παράγωγο',
    derivedTip: 'Αυτό το device ΑΝΗΚΕΙ στην παραγωγή του fabric (H2): ο επεξεργαστής αρνείται να το αγγίξει — αλλάξτε το fabric (ή την καλωδίωση) και εφαρμόστε ξανά, ή πάρτε το πίσω παρακάτω.',
    takeOwnership: 'Ανάληψη κυριότητας',
    takeOwnershipTitle: 'Ανάληψη κυριότητας (take-ownership)',
    takeOwnershipConfirm: 'Το {name} φεύγει από το μπλοκ fabric και ξαναγίνεται ΧΕΙΡΟΚΙΝΗΤΟ device που κυβερνά αυτός ο επεξεργαστής. Ο κόμβος γίνεται αποκλίνων, και το επόμενο apply της παραγωγής θα απορρίψει πάνω του (manualConflict) μέχρι να το μετονομάσετε ή να το αφαιρέσετε — ή να διορθώσετε το fabric.',
    nodeSettingsTitle: 'Ρυθμίσεις κόμβου',
    nodeSettingsSubtitle: 'Ό,τι επιβάλλει αυτός ο κόμβος — ουρά εργασιών, κονσόλα, προώθηση αρχείων καταγραφής — συν τις ετικέτες και τις σημειώσεις του',
    baseTitle: 'Δεσμεύσεις host (TVirt Proximity)',
    baseSubtitle: 'CPU και RAM δεσμευμένες για το λειτουργικό σύστημα του host — οι είσοδοι της εμπειρικής χωρητικότητας με την οποία το Proximity τοποθετεί τις VM',
    baseMemory: 'Βασική RAM (MiB)',
    baseMemoryHint: 'Παρατηρούμενο σύνολο: {total} MiB. Χρησιμοποιήσιμη για VM = σύνολο − βάση − RAM των ενεργών VM που έχουν τοποθετηθεί εδώ.',
    baseMemoryHintNoTotal: 'Χρησιμοποιήσιμη για VM = παρατηρούμενο σύνολο − βάση − RAM των ενεργών VM που έχουν τοποθετηθεί εδώ.',
    baseCpu: 'Βασικοί πυρήνες CPU',
    baseCpuHint: 'Παρατηρούμενες λογικές CPU: {total}. Χρησιμοποιούνται μόνο ως βάρος κατάταξης — το overcommit των vCPU είναι φυσιολογικό.',
    baseCpuHintNoTotal: 'Χρησιμοποιούνται μόνο ως βάρος κατάταξης — το overcommit των vCPU είναι φυσιολογικό.',
    baseHint: 'Η RAM είναι η αυστηρή πύλη εισδοχής: μια VM που δεν χωρά στη χρησιμοποιήσιμη RAM απορρίπτεται με εύγλωττο σφάλμα. Αυξήστε τη βάση στους host που φιλοξενούν μέλη της αποθήκης ή δαίμονες Ceph.',
    placementTitle: 'Φυσική τοποθέτηση',
    placementSubtitle: 'Πού βρίσκεται φυσικά αυτός ο διακομιστής — δηλώνεται μία φορά, ό,τι κι αν εξυπηρετεί',
    placementHint: 'Η τοποθέτηση καθοδηγεί την ιεραρχία CRUSH κάθε συστοιχίας Ceph με OSD σε αυτόν τον διακομιστή: η αποθήκευση μιας αλλαγής ευθυγραμμίζει ξανά τους χάρτες τους μέσω εργασίας (host → rack → … → root). Οι μερικές δηλώσεις είναι θεμιτές — τα κενά επίπεδα απλώς καταρρέουν. Τα ονόματα είναι κοινά σε όλον τον χάρτη: δύο διακομιστές στο ίδιο rack δηλώνουν το ίδιο όνομα rack.',
    placementNameInvalid: 'Όνομα ασφαλές για DNS (πεζά γράμματα, ψηφία, παύλες)',
    placementEmpty: 'Κενό = μη δηλωμένο',
    placementLevel: {
      chassis: 'Σασί',
      rack: 'Rack',
      row: 'Σειρά',
      pdu: 'PDU',
      pod: 'Pod',
      room: 'Αίθουσα',
      datacenter: 'Datacenter',
      zone: 'Ζώνη',
      region: 'Περιοχή'
    },
    cablingTitle: 'Καλωδίωση',
    cablingSubtitle: 'Σε ποια θύρα του μεταγωγέα συνδέεται κάθε διεπαφή — η δήλωση ζει στον κόμβο (Annex O.9)',
    cablingHint: 'Ένα καλώδιο ανά NIC, ένα καλώδιο ανά θύρα σε όλον τον στόλο (το API απορρίπτει κατονομάζοντας τον κάτοχο). Η καλωδίωση προς θύρα-μέλος ενός LAGG είναι θεμιτή — είναι η περίπτωση bond: η μελλοντική παραγωγή θα την αποδώσει ως LACP.',
    cablingInterface: 'Διεπαφή',
    cablingNotCabled: '— μη καλωδιωμένη —',
    cablingNoInterfaces: 'Καμία διεπαφή δικτύου δεν έχει παρατηρηθεί',
    disksTitle: 'Δίσκοι',
    disksSubtitle: 'Παρατηρούμενες συσκευές μπλοκ — μία σάρωση ανά πέρασμα συμφιλίωσης· επισημάνετε εδώ τους δίσκους που είναι χρησιμοποιήσιμοι ως OSD Ceph (N.15: η επιλεξιμότητα είναι ρητή)',
    colDataDisk: 'Δίσκος δεδομένων',
    dataDisksHint: 'Η επιλογή μιας συσκευής τη δηλώνει χρησιμοποιήσιμη ως OSD· ο σειριακός αριθμός είναι το pin ταυτότητάς της — αντιγράφεται από το υλικό όταν ο δίσκος τον αναφέρει, αλλιώς εκδίδεται (tvirt-…). Το παράθυρο διαλόγου εγγραφής Ceph προσφέρει μόνο τους δηλωμένους δίσκους.',
    diskDeclaredSerial: 'δηλωμένος',
    diskNotObserved: 'δηλωμένος αλλά μη παρατηρούμενος — επανασυνδέστε τη συσκευή ή αφαιρέστε την επιλογή',
    noDisks: 'Καμία συσκευή μπλοκ δεν έχει παρατηρηθεί ακόμη',
    colSerial: 'Σειριακός',
    colModel: 'Μοντέλο',
    colSize: 'Μέγεθος (GiB)',
    colDiskType: 'Τύπος',
    colInUse: 'Σε χρήση',
    colObservedAt: 'Παρατηρήθηκε',
    diskInUse: 'σε χρήση',
    diskFree: 'ελεύθερος',
    diskMounted: 'προσαρτημένος',
    diskPartitions: 'κατατμήσεις',
    passthroughTitle: 'Συσκευές passthrough',
    passthroughSubtitle: 'Παρατηρούμενες GPU και συσκευές USB — επισημάνετε εδώ τι μπορεί το TVirt να περάσει στις VM· η επισήμανση εγγράφει την ταυτότητα της συσκευής (γύρος U1+G1)',
    passthroughHint: 'Η επισήμανση εγγράφει τη συσκευή (ένα σταθερό id — ο στόχος των ετικετών και των απαιτήσεων κλάσης). Μια επισημασμένη GPU έχει ΟΛΟΚΛΗΡΗ την ομάδα IOMMU της δεμένη στο vfio-pci μονομιάς — εγκαταλείπει αμέσως τον host· η αναίρεση της επισήμανσης επαναδένει τον εγγενή driver. Για το USB υπάρχουν και τα δύο επικυρωμένα μοντέλα: ανά συσκευή (vendor+product, όπου κι αν είναι συνδεδεμένη) και ανά φυσική θύρα (η VM παίρνει ό,τι είναι συνδεδεμένο εκεί). Το USB δεν κάνει ποτέ bind κατά την επισήμανση — η προσάρτηση γίνεται κατά τον χρόνο εκτέλεσης της VM.',
    passthroughGpusTitle: 'GPU / PCIe',
    passthroughUsbTitle: 'USB',
    colUsable: 'Χρησιμοποιήσιμη από το TVirt',
    colGpu: 'GPU',
    colPciAddress: 'Διεύθυνση PCI',
    colDriver: 'Driver',
    colVerdict: 'Ετυμηγορία',
    gpuEligible: 'Επιλέξιμη',
    gpuIneligible: 'Μη επιλέξιμη',
    gpuReason: {
      'no-iommu': 'το IOMMU δεν είναι ενεργό στον host',
      'group-spans-slots': 'η ομάδα IOMMU δεν είναι απομονωμένη: εκτείνεται σε άλλες υποδοχές',
      'multiple-display': 'η ομάδα IOMMU δεν είναι απομονωμένη: περισσότερες από μία λειτουργίες οθόνης',
      'foreign-function': 'η ομάδα IOMMU δεν είναι απομονωμένη: περιέχει ξένη λειτουργία'
    },
    vfioNotReady: 'Το IOMMU δεν είναι ενεργό σε αυτόν τον host: καμία GPU δεν είναι επιλέξιμη μέχρι η πλατφόρμα του host να το ενεργοποιήσει (ISO OEM) — το TVirt δεν πειράζει ποτέ τα kernel args σε χρόνο εκτέλεσης.',
    vfioMissingKernelArg: 'Το IOMMU δεν είναι ενεργό σε αυτόν τον host: το υλικολογισμικό αναφέρει VT-d/AMD-Vi (παρών πίνακας ACPI DMAR/IVRS) αλλά λείπει το kernel arg — προσθέστε intel_iommu=on (Intel) ή αφαιρέστε το amd_iommu=off (AMD) από τη γραμμή εντολών του πυρήνα και επανεκκινήστε. Το TVirt δεν πειράζει ποτέ τα kernel args σε χρόνο εκτέλεσης.',
    vfioFirmwareDisabled: 'Το IOMMU δεν είναι ενεργό σε αυτόν τον host: το VT-d/AMD-Vi είναι απενεργοποιημένο στο υλικολογισμικό (κανένας πίνακας ACPI DMAR/IVRS) ή η CPU δεν το υποστηρίζει — ενεργοποιήστε το στη ρύθμιση του υλικολογισμικού, κανένα kernel arg δεν μπορεί να το ανάψει. Το TVirt δεν πειράζει ποτέ τον host σε χρόνο εκτέλεσης.',
    gpuBindError: 'Το bind vfio-pci απέτυχε στο {address}: {error}',

    // Firewall su bridge non gestiti (#168 §9-bis): la lista del consenso.
    firewallBridgesTitle: 'Τείχος προστασίας σε μη διαχειριζόμενες γέφυρες',
    firewallBridgesSubtitle: 'Οι χειροποίητες γέφυρες σε αυτόν τον κόμβο των οποίων η εγκατάσταση συναινεί στις αλυσίδες τείχους προστασίας που αποδίδει το TVirt στις προσαρτημένες NIC των guest',
    firewallBridgesHint: 'Το TVirt δεν αγγίζει ποτέ την ξένη γέφυρα — η αλυσίδα αγκυρώνεται στο tap/veth, που είναι πάντα του TVirt. Η λίστα είναι μια πύλη συναίνεσης: το default-deny και το anti-spoof μπορούν να σπάσουν ό,τι περιμένει μια χειροκίνητη εγκατάσταση, οπότε μια NIC με τείχος προστασίας σε μη διαχειριζόμενη γέφυρα που ΔΕΝ είναι εδώ στη λίστα απορρίπτεται με εύγλωττο σφάλμα.',
    firewallBridgesEmpty: 'Καμία μη διαχειριζόμενη γέφυρα δεν συναινεί στις αλυσίδες τείχους προστασίας που αποδίδει το TVirt σε αυτόν τον κόμβο.',
    firewallBridgeAdd: 'Προσθήκη γέφυρας',
    firewallBridgeInvalid: 'Δεν είναι όνομα διεπαφής Linux (1-15 χαρακτήρες, χωρίς κάθετο ή κενό)',
    firewallBridgeDuplicate: 'Το όνομα είναι ήδη στη λίστα',
    colMarkDevice: 'Ανά συσκευή',
    colMarkPort: 'Ανά θύρα',
    usbHub: 'hub',
    colUsbId: 'Vendor:Product',
    colPort: 'Θύρα',
    passthroughOrphan: 'ορφανή — εγγεγραμμένη αλλά δεν ανιχνεύεται πια: επανασυνδέστε την ή αναιρέστε την επισήμανσή της',
    noGpus: 'Καμία GPU δεν έχει παρατηρηθεί ακόμη',
    noUsb: 'Καμία συσκευή USB δεν έχει παρατηρηθεί ακόμη',
    networkGeneration: 'Γενιά δικτύου',
    applied: 'Εφαρμόστηκε',
    converged: 'ευθυγραμμισμένη',
    behind: 'πίσω — {m} / {n}',
    notConfigured: 'μη διαμορφωμένη',
    rollbackBody: 'Η εφαρμογή της γενιάς {gen} απέτυχε: {error}',
    rolledBackChip: 'έγινε rollback',
    nicsTitle: 'NIC',
    nicsSubtitle:
      'Το ευρετήριο των διαχειριζόμενων NIC — η εγγραφή ΕΙΝΑΙ η δήλωση διαχείρισης: μια εγγεγραμμένη NIC χωρίς διαμόρφωση δεν αγγίζεται (το clear-if τη δηλώνει ρητά καθαρή), μια μη εγγεγραμμένη συσκευή δεν αγγίζεται ποτέ',
    addNic: 'Εγγραφή NIC',
    addNicTitle: 'Εγγραφή NIC (add-nic)',
    delNic: 'Τερματισμός διαχείρισης',
    delNicTitle: 'Τερματισμός διαχείρισης (del-nic)',
    delNicConfirm:
      'Η διαχείριση του {name} τερματίζεται: η καταχώριση του ευρετηρίου και η διαμόρφωσή της διαγράφονται και το προφίλ TVirt αφαιρείται — η συσκευή μένει όπως την έχει το Linux.',
    nicName: 'Όνομα συσκευής',
    nicMac: 'Μόνιμη διεύθυνση MAC',
    nicMacHint: 'η μόνιμη MAC του υλικού — η σταθερή ταυτότητα που ορίζεται από τον TVirt Server Installer',
    colObserved: 'Παρατηρήθηκε',
    nicObserved: 'παρατηρούμενη',
    nicNotObserved: 'μη παρατηρούμενη',
    nicMacMismatch: 'Αναντιστοιχία MAC — παρατηρήθηκε {mac}',
    noNics: 'Καμία εγγεγραμμένη NIC — εγγράψτε μια συσκευή για να αρχίσετε να τη διαχειρίζεστε',
    noManagedDevices: 'Καμία διαχειριζόμενη συσκευή — εγγράψτε πρώτα μια NIC, όλα χτίζονται πάνω στο ευρετήριο',
    inventoryTitle: 'Παρατηρούμενες συσκευές',
    inventorySubtitle: 'Ανανεώνονται σε κάθε πέρασμα συμφιλίωσης από τον worker του κόμβου — η επικύρωση ελέγχει τα ονόματα των συσκευών σε αυτήν την απογραφή',
    colDevice: 'Συσκευή',
    colType: 'Τύπος',
    colMac: 'MAC',
    colLink: 'Link',
    colSpeed: 'Ταχύτητα',
    colTopology: 'Τοπολογία',
    colMtu: 'MTU',
    colAddresses: 'Διευθύνσεις',
    linkUp: 'up',
    linkDown: 'down',
    lacpDegraded: 'Το LACP δεν συναθροίζει',
    noInventory: 'Καμία συσκευή δεν έχει αναφερθεί μέχρι τώρα',
    interfacesTitle: 'Διεπαφές',
    interfacesSubtitle:
      'Διαμόρφωση L3 των εγγεγραμμένων NIC και των δηλωμένων λογικών συσκευών — το set-if αντικαθιστά ολόκληρο το μπλοκ, το edit-if διορθώνει επιμέρους ιδιότητες, το clear-if το αδειάζει (ρητός καθαρισμός)',
    colConfig: 'Επιθυμητή διαμόρφωση',
    clean: 'καθαρή',
    setIf: 'Επεξεργασία διευθυνσιοδότησης',
    setIfTitle: 'Επεξεργασία διευθυνσιοδότησης (set-if)',
    editIf: 'Επεξεργασία ιδιοτήτων',
    editIfTitle: 'Επεξεργασία ιδιοτήτων (edit-if)',
    clearIf: 'Εκκαθάριση διαμόρφωσης',
    clearIfTitle: 'Εκκαθάριση διαμόρφωσης (clear-if)',
    clearIfConfirm: 'Η διαμόρφωση της διεπαφής αδειάζει. Μια καθαρή διεπαφή είναι η προϋπόθεση για να ενταχθεί ως μέλος bond/γέφυρας ή ως γονέας VLAN.',
    ip4Mode: 'Λειτουργία IPv4',
    ip6Mode: 'Λειτουργία IPv6',
    modeUnconfigured: 'Μη διαμορφωμένη',
    modeStatic: 'Στατική',
    modeDhcp: 'DHCP',
    ip4Addresses: 'Διευθύνσεις IPv4',
    ip6Addresses: 'Διευθύνσεις IPv6',
    addressesHint: 'CIDR, διαχωρισμένα με κόμμα',
    gw4: 'Πύλη IPv4',
    gw6: 'Πύλη IPv6',
    dns: 'Διακομιστές DNS',
    dnsHint: 'διαχωρισμένοι με κόμμα — κενό μηδενίζει το DNS (το set-if αντικαθιστά το μπλοκ)',
    routes4: 'Στατικές διαδρομές IPv4',
    routes6: 'Στατικές διαδρομές IPv6',
    routeTo: 'Προορισμός (CIDR)',
    routeVia: 'Μέσω',
    addRoute: 'Προσθήκη διαδρομής',
    routesChip: 'διαδρομές',
    mtu: 'MTU',
    mtuHint: 'κενό = προεπιλογή του driver',
    vlansTitle: 'VLAN',
    addVlan: 'Προσθήκη VLAN',
    addVlanTitle: 'Προσθήκη VLAN (add-vlan)',
    delVlanTitle: 'Διαγραφή VLAN (del-vlan)',
    vlanParent: 'Γονική διεπαφή',
    vlanId: 'ID VLAN',
    vlanPreview: 'Όνομα συσκευής',
    colParent: 'Γονέας',
    colVlanId: 'ID',
    noVlans: 'Καμία δηλωμένη VLAN',
    bondsTitle: 'Bond',
    addBond: 'Προσθήκη bond',
    addBondTitle: 'Προσθήκη bond (add-bond)',
    editBondTitle: 'Επεξεργασία bond',
    editBond: 'Αποθήκευση bond',
    delBondTitle: 'Διαγραφή bond (del-bond)',
    bondName: 'Όνομα bond',
    members: 'Μέλη',
    membersHint: 'τα μέλη πρέπει να είναι καθαρές διεπαφές (χωρίς διαμόρφωση L3)',
    bondMode: 'Λειτουργία',
    modeActiveBackup: 'active-backup',
    modeLacp: 'LACP (802.3ad)',
    miimon: 'miimon (ms)',
    primary: 'Πρωτεύον μέλος',
    rate: 'Ρυθμός LACP',
    hash: 'Πολιτική hash μετάδοσης',
    colMembers: 'Μέλη',
    colMode: 'Λειτουργία',
    noBonds: 'Κανένα δηλωμένο bond',
    bridgesTitle: 'Γέφυρες',
    addBridge: 'Προσθήκη γέφυρας',
    addBridgeTitle: 'Προσθήκη γέφυρας (add-bridge)',
    editBridgeTitle: 'Επεξεργασία γέφυρας',
    editBridge: 'Αποθήκευση γέφυρας',
    delBridgeTitle: 'Διαγραφή γέφυρας (del-bridge)',
    bridgeName: 'Όνομα γέφυρας',
    stp: 'STP',
    stpOn: 'STP ενεργό',
    stpOff: 'STP ανενεργό',
    colStp: 'STP',
    noBridges: 'Καμία δηλωμένη γέφυρα',
    hostnameTitle: 'Hostname',
    hostname: 'Hostname',
    setHostname: 'Ορισμός hostname',
    setHostnameTitle: 'Ορισμός hostname (set-hostname)',
    hostnameHint: 'Μόνο ταυτότητα λειτουργικού — το όνομα του κόμβου στη συστοιχία δεν αγγίζεται',
    notSet: 'δεν έχει οριστεί',
    staticHostsTitle: 'Στατικές καταχωρίσεις host',
    addStaticHost: 'Προσθήκη καταχώρισης',
    addStaticHostTitle: 'Προσθήκη στατικής καταχώρισης host',
    delStaticHostTitle: 'Διαγραφή στατικής καταχώρισης host',
    hostIp: 'Διεύθυνση IP',
    hostNames: 'Ονόματα',
    hostNamesHint: 'διαχωρισμένα με κόμμα ή κενό',
    colIp: 'IP',
    colNames: 'Ονόματα',
    noStaticHosts: 'Καμία στατική καταχώριση host',
    delConfirm: 'Αφαίρεση του {name} από το επιθυμητό έγγραφο — ο worker του κόμβου συγκλίνει με checkpoint του NetworkManager και αυτόματο rollback.',
    remove: 'Αφαίρεση',
    opError: 'Η ενέργεια δικτύου απορρίφθηκε'
  }
}
